

const Futurize = ( ) => {
 
  
    return (
        <div >
          
    </div>
  )
}
 
export default Futurize;